<script setup>
import store from '@/store';
import router from '@/router';
import dayjs from 'dayjs';
import { onBeforeMount, onUnmounted } from 'vue';

const emits = defineEmits(['close']);

const selectDate = store.getters['diary/selectDate'];
const events = store.getters['diary/fetchDiaryList'];

onBeforeMount(() => {
  store.commit('layout/setIsNav', false);
});

onUnmounted(() => {
  store.commit('layout/setIsNav', true);
});

const fnEventSelect = event => {
  emits('close');
  store.commit('diary/setDetail', event);

  if (event.diaryNo != null) {
    router.push(`/diary/user/${event.diaryNo}`);
  } else {
    router.push(`/diary/church/${event.churchDiaryNo}`);
  }
};

const fnRouteForm = () => {
  const date = store.getters['diary/date'];
  emits('close');
  router.push({
    path: '/diary/form',
    query: { date: date }
  });
};

const formatDateToTime = date => {
  return dayjs(date).format('HH:mm');
};
</script>

<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-con">
            <div class="schedule-list-wrap">
              <p class="today-date">{{ selectDate }}일</p>
              <div class="scroll-inner">
                <ul class="schedule-list">
                  <li class="card heightFit" v-for="(event, idx) in events" :key="idx">
                    <div class="card-inner" @click="fnEventSelect(event)">
                      <div class="title-wrap flex-justi-con-space-between flex-align-item-center">
                        <div class="schedule-wrap">
                          <span class="time">{{ formatDateToTime(event.date) }}</span>
                          <div class="title">
                            {{ event.title?.length > 24 ? event.title.substring(0, 24) + '...' : event.title }}
                          </div>
                        </div>
                        <i class="ico-arrow-right-gray50"></i>
                      </div>
                      <div class="text-wrap">
                        <p class="text">
                          {{ event.contents?.length > 24 ? event.contents.substring(0, 24) + '...' : event.contents }}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn medium border-gray" @click="$emit('close')">닫기</button>
              <button class="btn primary medium" @click="fnRouteForm">추가하기</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div></template
>

<style scoped></style>
